import { VStack } from "@/components/layout";
import Tabs from "@/components/tabs";
import Header from "../header";
import DaystromAi from "./daystrom-ai";
import useProcessedPages from "./hooks/use-processed-pages";

export { default as AiAnalysisView } from "./ai-analysis";
export { default as LocationsView } from "./locations";
export { default as ProjectOverviewView } from "./overview";

export default function Processed({ project, metadata, children }) {
  const [pages, selectedPage] = useProcessedPages(project, metadata);
  return (
    <VStack className="size-full justify-between">
      <div className="w-full">
        <Header project={project} />
        <Tabs key={selectedPage} tabs={pages} initialTab={selectedPage} />
        <DaystromAi project={project} />
        {children}
      </div>
    </VStack>
  );
}
